import { render } from "./ProductPagination.vue?vue&type=template&id=e8d4663c"
import script from "./ProductPagination.vue?vue&type=script&lang=js"
export * from "./ProductPagination.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nunosarabando/projects/TravocarStore_2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__